import React, { useState, useEffect } from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import DataGridComponent from "../Widgets/DataGridComponent";
import { t } from "react-i18nify";
import { useEditionRightsPerUserStatus } from "../../js/utils/customHooks";
import { docsStats } from "../../js/constants/selectOptions";
import { useSelector } from "react-redux";
import { FilterToolbar } from "../Widgets/Custom Inputs/Select";


const DocumentsStatsGrid = ({ label, baseURL, ...props }) => {
    const apiRef = useGridApiRef();
    const locale = useSelector(state => state.i18n.locale);

    const [lastTwelveMonths, setLastTwelveMonths] = useState([]);
    const [selectedStats, setSelectedStats] = useState("Delta");

    const languages = {
        'ENG': 'en-US',
        'FRA': 'fr-FR',
        'SPA': 'es-ES',
        'POR': 'pt-PT',
        'NLD': 'nl-NL',
        'DEU': 'de-DE'
    };

    /* eslint-disable */
    const getLastTwelveMonths = () => {
        const months = [];
        const currentDate = new Date();
        
        for(let i = 0; i < 12; i++) {
            const month = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
            const year = month.getFullYear().toString().slice(-2);
            const monthName = month.toLocaleString(languages[locale], { month: 'short' });
            months.push({
                field: `Month${i+1}`,
                headerName: `${monthName}-${year}`,
                flex: 1,
                editable: true,
                minWidth: 70
            });
        }

        return months;
    };

    useEffect(() => {
        setLastTwelveMonths(getLastTwelveMonths());
    }, []);

    /* eslint-disable */
    
    const editingRights = useEditionRightsPerUserStatus([
        "EntityManager",
        "Editor",
        "Contributor",
    ]);
    
    const gridSpecificColumns = [
        {
            field: "EntityName",
            headerName: t("field.Entity"),
            flex: 1,
            editable: true,
            minWidth: 210,
        },
        {
            field: "NumberOfDocuments",
            headerName: "#",
            flex: 1,
            editable: true,
            minWidth: 65
        }
    ].concat(lastTwelveMonths);


    return (
        <>
            <DataGridComponent
                apiRef={apiRef}
                baseURL={"Document/GetDocumentsStats"}
                label={label}
                gridSpecificColumns={gridSpecificColumns}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "EntityName", sort: "asc" }],
                    },
                    pinnedColumns: {
                        left: [`EntityName`]
                    }
                }}
                editingRights={editingRights}
                getDetailPanelHeight={() => "auto"}
                isAddDisabled={true}
                hideActionColumn={true}
                toolbar={{
                    newFilter: (
                        <FilterToolbar
                            options={docsStats.map(e => ({
                                ...e,
                                label: t(`diagram.${e.label}`)
                            }))}
                            disableClearable
                            placeholder={"Delta"}
                            value={selectedStats}
                            onChange={(e, value) =>
                                value
                                    ? setSelectedStats(t(`diagram.${value.value}`))
                                    : setSelectedStats("")
                            }
                        />
                    ),
                }}
                paramURL={
                    selectedStats
                        ? `filter[Stats]=${selectedStats}`
                        : ""
                }
                {...props}
            />
        </>
    );
};

export default DocumentsStatsGrid;
